import DynamicForm from './container';

export default DynamicForm;
